<template>
  <div>
    <common-dialog
      ref="dialog"
      width="995px"
      unit="投资环境"
      id-key="RecordId"
      :data="data"
      :get-data-func="api.info"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
      :before-save="onBeforeSave"
      close-on-saved
      form-label-width="85px"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" prop="InfoTitle">
              {{ data.InfoTitle }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="类别" prop="InfotypeId">
              {{ data.TypeName }}
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="信息来源" prop="InfoSource">
              {{ data.InfoSource }}
            </el-form-item>
          </el-col>
          
          <el-col :span="24">
            <el-divider>内容</el-divider>
            <div v-html="data.InfoContent"></div>
          </el-col>
          <el-col :span="24">
            <el-form-item label="简介" prop="InfoBrief">
              {{ data.InfoBrief }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="isMB?'':'缩略图'" :label-width="isMB?'0':''" prop="PhotoAddress">
              <el-divider v-if="isMB">缩略图</el-divider>
              <single-pic-upload
                v-model="data.PhotoAddress"
                type="PhotoAddress"
                :uploadUrl="uploadUrl"
                IsDetail
              ></single-pic-upload>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:6">
            <el-form-item label="发布日期" prop="ReleaseTime">
              {{ $commonJs.toDateString(data.ReleaseTime) }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否置顶" prop="IfTop">
              {{ data.IfTop==1?"是":"否" }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="序号" prop="OrderId">
              {{ data.OrderId }}
            </el-form-item>
          </el-col>
         
        </el-row>
        
      </template>
      <template slot="footer">
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        InfoTitle:"",
        InfotypeId: null,
        TypeName: "",
        InfoSource: "",
        InfoLink: "",
        InfoContent: "",
        InfoContentText: "",
        InfoBrief: "",
        IfTop: 1,
        PhotoAddress: "",
        ReleaseTime: "",
        InfoAttach: "",
        State: 0,
      },
      fl: [],
      tableData: [],
      api: require("@/api/policy/detail").default,
      isMB: this.$store.state.isMB,
      rules: {
        InfoTitle:[{ required: true, message: "标题不能为空" }],
        InfoContent: [{ required: true, message: "内容不能为空" }],
       
        InfotypeId: [{ required: true, message: "类别不能为空" }],
        ReleaseTime: [{ required: true, message: "发布日期不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      uploadUrl:"/api/Common/UploadPicture",
    };
  },
  methods: {
    onCreateOpened(data) {
    },
    onDetailsOpened(data) {
      if(data.InfoAttach) this.fl.push({ name: "附件." + data.InfoAttach.split(".")[1], url: '/api' + data.InfoAttach, url2: data.InfoAttach })
     
      
    },
    dlfile(file) {
      const elink = document.createElement("a");
      elink.download = file.name;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = this.host + file.url;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    pass() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
            this.api.pass(this.data.RecordId).then(res => {
              this.loading(false);
              if(res.Code==0) {
                this.$message.success(res.Msg);
                this.$emit("close-saved");
                this.close(true);
              } else {
                this.$message.error(res.Msg);
              }
            })
        })
        .catch(() => {});
    },
    noPass() {
      this.$confirm("确认不通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
            this.api.noPass(this.data.RecordId).then(res => {
              this.loading(false);
              if(res.Code==0) {
                this.$message.success(res.Msg);
                this.$emit("close-saved");
                this.close(true);
              } else {
                this.$message.error(res.Msg);
              }
            })
        })
        .catch(() => {});
    },
    cancel() {
      this.$confirm("确认撤销审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
            this.api.cancelReview(this.data.RecordId).then(res => {
              this.loading(false);
              if(res.Code==0) {
                this.$message.success(res.Msg);
                this.$emit("close-saved");
                this.close(true);
              } else {
                this.$message.error(res.Msg);
              }
            })
        })
        .catch(() => {});
    },
    onBeforeSave() {
      return false;
    },
    onClosed() {
      this.tableData = [];
      this.fl = [];
    },
  }
};
</script>
<style lang="scss">
.file-text2{
  .el-upload--text {
    display: none;
  }
  .el-upload-list__item-name {
    margin-top: -8px;
  }
}
</style>